// extracted by mini-css-extract-plugin
export default {"badgeIcon":"FileContentIcon_badgeIcon__KgaQc"};